import { Button, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, TextField } from "@mui/material"
import { forwardRef, useState } from "react"
import { NumericFormat } from "react-number-format"
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"

import "dayjs/locale/he"

const NumericFormatCustom = forwardRef(function NumericFormatCustom(props, ref) {
	const { onChange, ...other } = props

	return (
		<NumericFormat
			{...other}
			getInputRef={ref}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				})
			}}
			thousandSeparator
			valueIsNumericString
		/>
	)
})

const FakeBidDialog = ({ fakeBidDialog, setFakeBidDialog, okCallback }) => {
	const [fakeBidAmount, setFakeBidAmount] = useState(0)
	const [fakeBidDateTime, setFakeBidDateTime] = useState(null)

	const handleOk = () => {
		console.log(fakeBidAmount)
		console.log(fakeBidDateTime.toDate())
		okCallback(fakeBidAmount, fakeBidDateTime.toDate())
		setFakeBidDialog(false)
		setFakeBidAmount(0)
		setFakeBidDateTime(null)
	}

	const handleClose = () => {
		setFakeBidDialog(false)
		setFakeBidAmount(0)
	}

	return (
		<Dialog open={fakeBidDialog} onClose={handleClose}>
			<DialogTitle>חילול הצעה ח</DialogTitle>
			<DialogContent>
				{/* <DialogContentText>חילול הצעה ח</DialogContentText> */}
				<TextField
					label={"הצעה"}
					value={fakeBidAmount}
					onChange={(e) => setFakeBidAmount(e.target.value)}
					size="small"
					sx={{ m: 2, maxHeight: "36px" }}
					InputProps={{
						endAdornment: <InputAdornment position="start">ש״ח</InputAdornment>,
						inputComponent: NumericFormatCustom,
					}}
				/>
				<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"he"}>
					<DateTimePicker
						label="תאריך"
						value={dayjs(fakeBidDateTime)}
						onChange={(newValue) => {
							setFakeBidDateTime(newValue)
						}}
						slotProps={{ textField: { size: "small" } }}
						sx={{ m: 2, minWidth: "110px" }}
					/>
				</LocalizationProvider>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setFakeBidDialog(false)}>ביטול</Button>
				<Button
					onClick={() => handleOk()}
					autoFocus
					disabled={!(!isNaN(parseInt(fakeBidAmount)) && fakeBidAmount?.length > 0)}
				>
					המשך
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default FakeBidDialog
